/** Map showcase / API labels to country page slug names in countriesData. */
const NAV_COUNTRY_ALIASES: Record<string, string> = {
  UAE: 'United Arab Emirates',
  UK: 'United Kingdom',
}

export function countryPathName(displayName: string): string {
  return NAV_COUNTRY_ALIASES[displayName] ?? displayName
}
